import { PdfTemplateListItem } from '@vpfa/shared/interfaces';
import { DataTableValueGetterParams } from '@vpfa/ui-kit/data-table';

export const defaultActionGetter = (params: DataTableValueGetterParams<PdfTemplateListItem>) => {
  return null;
};
